import { useCallback } from "react";
import { useLocation } from "react-router-dom";

export const useIsPageActive = () => {
  const location = useLocation();

  return useCallback(
    (page: string | string[]) => {
      const path = location.pathname.toLowerCase();
      if (typeof page === "string") {
        return path.startsWith(page.toLowerCase());
      }

      return page.some((p) => path.startsWith(p.toLowerCase()));
    },
    [location.pathname],
  );
};
